import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/restaurant",
  name: "restaurantIndex",
  redirect: "/restaurant/Index",
  component: RouteView,
  meta: {
    title: "桌台详情",
    showNavBar: false,
  },
  children: [
    {
      path: "/restaurant/Index",
      name: "restaurantIndex",
      component: () => import("@/views/restaurant/Index.vue"),
      meta: {
        title: "桌台详情",
        toHome: false,
        isRestaurant: true,
      },
    },
    {
      path: "/restaurant/OrderFood",
      name: "restaurantOrderFood",
      component: () => import("@/views/restaurant/OrderFood.vue"),
      meta: {
        title: "点菜",
        toHome: false,
        isRestaurant: true,
      },
    },
    {
      path: "/restaurant/ConfirmOrder",
      name: "restaurantConfirmOrder",
      component: () => import("@/views/restaurant/ConfirmOrder.vue"),
      meta: {
        title: "确认订单",
        toHome: false,
        isRestaurant: true,
      },
    },
    {
      path: "/restaurant/Detail",
      name: "restaurantDetail",
      component: () => import("@/views/restaurant/Detail.vue"),
      meta: {
        title: "订单详情",
        toHome: false,
        isRestaurant: true,
      },
    },
    {
      path: "/restaurant/CheckOut",
      name: "restaurantCheckOut",
      component: () => import("@/views/restaurant/CheckOut.vue"),
      meta: {
        title: "结账",
        toHome: false,
        isRestaurant: true,
      },
    },
    {
      path: "/restaurant/PayResult",
      name: "restaurantPayResult",
      component: () => import("@/views/restaurant/PayResult.vue"),
      meta: {
        title: "支付结果",
        toHome: false,
        isRestaurant: true,
      },
    },
    {
      path: "/restaurant/OrderList",
      name: "restaurantOrderList",
      component: () => import("@/views/restaurant/OrderList.vue"),
      meta: {
        title: "我的订单列表",
        toHome: false,
        isRestaurant: true,
      },
    },
    {
      path: "/restaurant/BookingIndex",
      name: "restaurantBookingIndex",
      component: () => import("@/views/restaurant/BookingIndex.vue"),
      meta: {
        title: "订餐",
        toHome: false,
        isRestaurant: true,
      },
    },
    {
      path: "/restaurant/BookingList",
      name: "restaurantBookingList",
      component: () => import("@/views/restaurant/BookingList.vue"),
      meta: {
        title: "订餐列表",
        toHome: false,
        isRestaurant: true,
      },
    },
  ],
};
